import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabs: {}
};

const docketSlice = createSlice({
  name: "docket",
  initialState,
  reducers: {
    saveDocketData: (state, action) => {
      const { tabId, data, tab  } = action.payload;
      state.tabs[tabId] = { ...data, tab }; 
    },
    clearDocketData: (state) => {
      state.data = null;
    },
  },
});

export const { saveDocketData, clearDocketData } = docketSlice.actions;
export default docketSlice.reducer;
